import { UseFormHandleSubmit } from "react-hook-form";
import { useExpensesState } from "atoms/expensesAtom";

import { Button, EButtonVariant } from "components/Button/Button";

import { useAddArticle, useEditArticle } from "./api";
import { FormSalaryValues } from "./Salary";

type Props = {
  onSubmit: UseFormHandleSubmit<any>;
};

export const SalaryFooter = ({ onSubmit }: Props): JSX.Element => {
  const { mutate: addArticle } = useAddArticle();
  const { mutate: editArticle } = useEditArticle();
  const { expensesState, setExpensesState } = useExpensesState();

  const handleClick = (data: FormSalaryValues) => {
    const { name, isTerminal, position } = data;

    if (!name || !position) return;

    function onSuccess() {
      setExpensesState({ activeItem: null });
    }

    if (expensesState.activeItem) {
      editArticle(
        {
          showonfront: isTerminal ? 1 : 0,
          articleid: expensesState.activeItem.articleid,
          position: +position,
          name,
        },
        {
          onSuccess,
        }
      );
    } else {
      addArticle(
        { name, showonfront: isTerminal ? 1 : 0, position: +position },
        {
          onSuccess,
        }
      );
    }
  };

  return (
    <div className="flex flex-row ">
      <Button
        icon="galochka"
        variant={EButtonVariant.SECONDARY}
        onClick={onSubmit(handleClick)}
      >
        Сохранить
      </Button>
    </div>
  );
};
